import React, {useState, useEffect, useContext} from "react";
import styled from "styled-components";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Select from 'react-select'
import {DataContext} from "../../context/ContextData"
import { Input } from 'semantic-ui-react'
import moment from 'moment'

const ModalBody = () => {

  const [selectedDate, setSelectedDate] = useState(null)
  const [turnos, setTurnos] = useState(null)
  const [inicio, setInicio] = useState(null)
  const [fin, setFin] = useState(null)
  const [totalCortes, setTotalCortes] = useState(null)
  const [totalAfeitados, setTotalAfeitados] = useState(null)
  const [totalCortesYAfeitados, setTotalCortesYAfeitados] = useState(null)
  const [horariosDisponibles, setHorariosDisponibles] = useState(null)
  const [selectedTimes, setSelectedTimes] = useState([])

  function cargardatos () {
    fetch("https://adiosnonino.com/phpindex.php")
    .then(r => r.json())
    .then(r => setTurnosToday(r, barbero))
    .catch(e => console.log('failed'))
  }

  useEffect(() => {
    cargardatos()
  }, [])

  useEffect(() => {
    cargardatos()
  }, [selectedDate])

  useEffect(() => {
    if (inicio) {
      setFechaInicio(moment(inicio).format('YYYY-MM-DD'))
    }
  }, [inicio])

  useEffect(() => {
    if (fin) {
      setFechaFinal(moment(fin).format('YYYY-MM-DD'))
    }
  }, [fin])

  function setTurnosToday (turnos, barbero) {
    const fechaActual = selectedDate.toISOString().split('T')[0]
    const turnosFabri = turnos.filter(turno => (turno.barbero === barbero))
    const turnosFabriHoy = turnosFabri.filter(turno => turno.fecha === fechaActual)
    setTurnos(turnosFabriHoy)
    const horariosOcupados = turnosFabriHoy.length ? turnosFabriHoy.map(turno => turno.hora) : []
    if (servicio !== 'Corte y Afeitado') {
      setHorariosDisponibles(options.filter(hora => !horariosOcupados.includes(hora.value)))
    } else {
      const disponibles = options.filter(hora => !horariosOcupados.includes(hora.value))
      let disponiblesAmbos = []
      disponibles.forEach(hora => {
        const selectedIndex = options.indexOf(hora)
        const siguiente = options[selectedIndex + 1]
        if (disponibles.includes(siguiente)) {
          disponiblesAmbos.push(hora)
        }
      })
      setHorariosDisponibles(disponiblesAmbos)
    }
  }

  useEffect(() => {
    if (selectedDate) {
      setFecha(selectedDate.toISOString().split('T')[0])
    }
  }, [selectedDate])

  const {fecha,
      setFecha,
      hora,
      setHora,
      nombre,
      setNombre,
      barbero,
      setBarbero,
      servicio,
      setServicio,
      celular,
      setCelular,
      email,
      setEmail,
      timesToCancel,
      setTimesToCancel,
      dateToCancel,
      setDatesToCancel,
      fechaInicio,
      setFechaInicio,
      fechaFinal,
      setFechaFinal,
      dataEstadisticas,
      setDataEstadisticas} = useContext(DataContext)

  const options = [
    {value: '10:00', label: '10:00'},
    {value: '10:30', label: '10:30'},
    {value: '11:00', label: '11:00'},
    {value: '11:30', label: '11:30'},
    {value: '12:00', label: '12:00'},
    {value: '12:30', label: '12:30'},
    {value: '13:00', label: '13:00'},
    {value: '13:30', label: '13:30'},
    {value: '14:00', label: '14:00'},
    {value: '14:30', label: '14:30'},
    {value: '15:00', label: '15:00'},
    {value: '15:30', label: '15:30'},
    {value: '16:00', label: '16:00'},
    {value: '16:30', label: '16:30'},
    {value: '17:00', label: '17:00'},
    {value: '17:30', label: '17:30'},
    {value: '18:00', label: '18:00'},
    {value: '18:30', label: '18:30'}
  ]

  const barberoptions = [
    {value: 'Fabricio', label: 'Fabricio'},
  ]

  const serviciosDis = [
    {value: 'Corte', label: 'Corte'},
    {value: 'Afeitado', label: 'Afeitado'},
    {value: 'Corte y Afeitado', label: 'Corte y Afeitado'}
  ]

  function setSelectedTime (val, time) {
    if (val) {
      setSelectedTimes([...selectedTimes, time])
    } else {
      const filteredTimes = selectedTimes.filter(times => times !== time)
      setSelectedTimes(filteredTimes)
    }
  }

  function formatEstadisticas (stats) {
    setTotalCortes(stats.filter(stat => stat.servicio == 'Corte').length)
    setTotalAfeitados(stats.filter(stat => stat.servicio == 'Afeitado').length)
    setTotalCortesYAfeitados(stats.filter(stat => stat.servicio == 'Corte y Afeitado').length)
  }

  useEffect(() => {
    setTimesToCancel(selectedTimes)
  }, [selectedTimes])

  useEffect(() => {
    setDatesToCancel(moment(selectedDate).format('YYYY-MM-DD'))
  }, [selectedDate])

  useEffect(() => {
    if (dataEstadisticas) {
      formatEstadisticas(dataEstadisticas)
    }
  }, [dataEstadisticas])

  return (
    <BodyContainer>
      <div className="columnas">
        <label>Fecha de inicio</label>
        <DatePicker
          placeholderText="Fecha"
          className={"sarasa sarasapicker ui focus "}
          selected={inicio}
          onChange={date => setInicio(date)}
          dateFormat='yyyy-MM-dd'
          filterDate={date => date.getDay() !== 0 && date.getDay() !== 1}
        />
        <label>Fecha de corte</label>
        <DatePicker
          placeholderText="Fecha"
          className={"sarasa sarasapicker ui focus "}
          selected={fin}
          onChange={date => setFin(date)}
          dateFormat='yyyy-MM-dd'
          filterDate={date => date.getDay() !== 0 && date.getDay() !== 1}
        />
        <div>Total Cortes: { totalCortes }</div>
        <div>Total Afeitados: { totalAfeitados }</div>
        <div>Total Cortes y Afeitados: { totalCortesYAfeitados }</div>
      </div>
    </BodyContainer>
  );
};

export default ModalBody;

const BodyContainer = styled.div`
  display: flex;
  justify-content: space-between;

  .columnas {
    width: 50%;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  .columnas h6 {
    font-weight: bold;
    font-size: 1.3rem;
  }

  .columnas h2 {
    font-weight: bold;
    margin-bottom: 1rem;
  }

  .columnas span {
    font-size: 1rem;
  }

  .sarasapicker {
    margin: .5rem 0;
  }

  .sarasa {
    padding: .6rem;
    border-radius: .3rem;
    border-color: #D3D3D3;
    box-shadow: none;
    width: 100%;
    text-align: center;
  }

  .invisible {
    visibility:hidden;
  }

  .sarasa:focus {
    outline-color: #719ECE;
  }
`;